import type { IconData } from '@stacksjs/iconify-core'

export const xx1x1: IconData = {
  "body": "<path fill=\"#fff\" fill-rule=\"evenodd\" stroke=\"#adb5bd\" d=\"M.5.5h511v511H.5z\"/><path fill=\"none\" stroke=\"#adb5bd\" d=\"m.5.5l511 511m0-511l-511 511\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default xx1x1
